import { FC, useEffect, useMemo, useRef } from 'react'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { publicFiltersSelector } from 'selectors/publicDashboardSelectors'
import { getPublicTrendActionCreator } from 'actions/publicDashboardActions'
import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'
import { LineChartWrapper } from 'components/features/external/PublicSpendingTrend/LineChartWrapper'
import { isFetchableLoading } from 'helpers/loadableHelpers'
import styles from 'components/features/external/PublicSpendingTrend/PublicSpendingTrend.styl'

export const PublicSpendingTrend: FC = () => {
  const { incomeRange, category, location, timeframe } = useStoreSelector(publicFiltersSelector)

  const dispatch = useStoreDispatch()
  useEffect(() => {
    dispatch(getPublicTrendActionCreator.request({ incomeRange, category, location, timeframe }))
  }, [dispatch, incomeRange, category, location, timeframe])

  const trendState = useStoreSelector((state) => state.data.publicdashboard.trend)
  const { data } = trendState

  const preloaderChild = isFetchableLoading(trendState) && (
    <LoadingOverlay />
  )

  const keyRef = useRef<number>(0)
  const trendChild = useMemo(() => {
    if (!data) {
      return null
    }

    if (data.items.length === 0) {
      return (
        <div className={ styles.noData }>
          <div>
            No data
          </div>
        </div>
      )
    }
    return (
      <LineChartWrapper
        timeframe={ timeframe }
        items={ data.items }
        isPreliminary={ data.is_preliminary }
        key={ keyRef.current++ }
      />
    )
    // do not add `timeframe` to deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <div className={ styles.publicSpendingTrend }>
      { trendChild }
      { preloaderChild }
    </div>
  )
}
